import React, { useMemo, useRef, useState } from "react";

import philippines from "../assets/images/philippines.webp";
import korea from "../assets/images/korea.webp";
import nepal from "../assets/images/nepal.webp";
import dubai9 from "../assets/images/dubai9.webp";
import srilanka from "../assets/images/srilanka.webp";
import china from "../assets/images/china.webp";
import qatar from "../assets/images/qatar.webp";
import japan from "../assets/images/japan.webp";
import kenya from "../assets/images/kenya.webp";
import morocco from "../assets/images/morocco.webp";
import egypt from "../assets/images/egypt.webp";
import thailand from "../assets/images/thailand.webp";
import maldives from "../assets/images/maldives.webp";

const destinations = [
  {
    country: "Cambodia",
    title: "Fun Filled Exploration Of Cambodia 4 Days",
    places: "Siem Reap (3N)",
    cities: "1 city",
    duration: "4D/3N",
    rating: "4.9",
    oldPrice: "₹39,500",
    price: "₹31,500",
    image:
      "https://images.unsplash.com/photo-1601024445121-e5b11c606610?auto=format&fit=crop&w=1400&q=90",
  },
  {
    country: "Sri Lanka",
    title: "Lively Sri Lanka 4 Days",
    places: "Kandy, Bentota, Colombo",
    cities: "3 cities",
    duration: "4D/3N",
    rating: "4.8",
    oldPrice: "₹32,000",
    price: "₹25,000",
    image:
      "https://images.unsplash.com/photo-1586613832680-d4e0f5b8a6a3?auto=format&fit=crop&w=1400&q=90",
  },
  {
    country: "Malaysia",
    title: "Vibrant Malaysia 6 Days",
    places: "Langkawi, Kuala Lumpur",
    cities: "2 cities",
    duration: "6D/5N",
    rating: "4.9",
    oldPrice: "₹55,000",
    price: "₹45,000",
    image:
      "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?auto=format&fit=crop&w=1400&q=90",
  },
  {
    country: "Thailand",
    title: "Amazing Thailand Escape 5 Days",
    places: "Bangkok, Phuket",
    cities: "2 cities",
    duration: "5D/4N",
    rating: "4.9",
    oldPrice: "₹45,000",
    price: "₹36,000",
    image:
      "https://images.unsplash.com/photo-1528181304800-259b08848526?auto=format&fit=crop&w=1400&q=90",
  },
  {
    country: "Bali",
    title: "Beautiful Bali Getaway 5 Days",
    places: "Ubud, Kuta",
    cities: "2 cities",
    duration: "5D/4N",
    rating: "4.9",
    oldPrice: "₹49,000",
    price: "₹39,500",
    image:
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1400&q=90",
  },
];

function DestinationSection() {
  const sliderRef = useRef(null);

  const [activeCountry] = useState("United Arab Emirates");
  const [likedCards, setLikedCards] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);

  const filteredDestinations = useMemo(() => {
    if (activeCountry === "United Arab Emirates") {
      return [
        {
          country: "Philippines",
          title: "Premium Twin-City & Island Discovery Tour",
          places: "Philippines",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: philippines,
          href:'/contact'
        },
        {
          country: "China",
          title: "Discover Beijing | A Journey of Wonders",
          places: "China",
          cities: "2 cities",
          duration: "7D/6N",
          rating: "4.9",
          oldPrice: "₹65,455",
          price: "₹60,000",
          image: china,
          href:'/contact'
        },
        {
          country: "Nepal",
          title: "Nepal Tour Package with Chitwan National Park",
          places: "Nepal",
          cities: "1 city",
          duration: "5D/4N",
          rating: "5.0",
          oldPrice: "₹43,636",
          price: "₹40,000",
          image: nepal,
          href:'/contact'
        },

        // Dubai
        // {
        //   country: "Dubai",
        //   title: "Premium Tour with Atlantis & City Highlights",
        //   places: "Dubai",
        //   cities: "2 cities",
        //   duration: "7D/6N",
        //   rating: "4.9",
        //   oldPrice: "₹65,455",
        //   price: "₹60,000",
        //   image: dubai9,
        // },

        {
          country: "Korea",
          title: "South Korea Getaway | Lights, Camera & K-Pop",
          places: "Korea",
          cities: "1 city",
          duration: "5D/4N",
          rating: "5.0",
          oldPrice: "₹43,636",
          price: "₹40,000",
          image: korea,
          href:'/contact'
        },
        {
          country: "Qatar",
          title:
            "Ultimate Qatar | City Tours, Safaris and Kayaking Adventures",
          places: "Qatar",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: qatar,
          href:'/contact'
        },
        {
          country: "Sri Lanka",
          title:
            "Sri Lanka Highlights | Getaway to the Pearl of Indian Ocean",
          places: "Sri Lanka",
          cities: "1 city",
          duration: "5D/4N",
          rating: "5.0",
          oldPrice: "₹43,636",
          price: "₹40,000",
          image: srilanka,
          href:'/contact'
        },
        {
          country: "Maldives",
          title: "Dreamland Maldives Escape – Tropical Luxury Getaway",
          places: "Maldives",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: maldives,
          href:'/contact'
        },
        {
          country: "Japan",
          title: "Legends of Japan | Journey Across Diverse Landscapes",
          places: "Japan",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: japan,
          href:'/contact'
        },
        {
          country: "Thailand",
          title: "Wonders of Thailand | Culture, Corals and Coastlines",
          places: "Thailand",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: thailand,
          href:'/contact'
        },
        {
          country: "Kenya",
          title: "Kenya Wildlife & Scenic Adventure",
          places: "Kenya",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: kenya,
          href:'/contact'
        },
        {
          country: "Egypt",
          title: "Timeless Odyssey of Egypt | Hieroglyphs and Horizons",
          places: "Egypt",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: egypt,
          href:'/contact'
        },
        {
          country: "Morocco",
          title: "Timeless Morocco | Discover Marrakech and Fes",
          places: "Morocco",
          cities: "2 cities",
          duration: "8D/7N",
          rating: "4.9",
          oldPrice: "₹1,59,273",
          price: "₹1,46,000",
          image: morocco,
          href:'/contact'
        },
      ];
    }

    return destinations;
  }, [activeCountry]);

  const displayDestinations =
    filteredDestinations.length > 0
      ? filteredDestinations
      : destinations.slice(0, 3);

  /*
   * Get all destination cards.
   *
   * IMPORTANT:
   * Your cards are <div> elements, not <a> or <article>.
   * So we use the data-slide-card attribute to find them.
   */
  const getCards = () => {
    if (!sliderRef.current) return [];

    return Array.from(
      sliderRef.current.querySelectorAll("[data-slide-card]")
    );
  };

  /*
   * Move the slider to a specific card.
   */
  const scrollToSlide = (index) => {
    const cards = getCards();

    if (!cards.length) return;

    const safeIndex = Math.max(0, Math.min(index, cards.length - 1));

    cards[safeIndex].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });

    setActiveSlide(safeIndex);
  };

  /*
   * Previous / Next arrow functionality.
   */
  const scrollSlider = (direction) => {
    const cards = getCards();

    if (!cards.length) return;

    const currentIndex = activeSlide;

    let nextIndex;

    if (direction === "next") {
      nextIndex = Math.min(currentIndex + 1, cards.length - 1);
    } else {
      nextIndex = Math.max(currentIndex - 1, 0);
    }

    scrollToSlide(nextIndex);
  };

  /*
   * Detect which card is currently visible.
   */
  const handleSliderScroll = () => {
    const slider = sliderRef.current;

    if (!slider) return;

    const cards = getCards();

    if (!cards.length) return;

    const sliderRect = slider.getBoundingClientRect();

    let closestIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const cardRect = card.getBoundingClientRect();

      const distance = Math.abs(
        cardRect.left - sliderRect.left
      );

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    setActiveSlide(closestIndex);
  };

  const toggleWishlist = (index) => {
    setLikedCards((prev) =>
      prev.includes(index)
        ? prev.filter((item) => item !== index)
        : [...prev, index]
    );
  };

  const handleExplore = (destination) => {
    window.dispatchEvent(
      new CustomEvent("open-agent-modal", {
        detail: destination,
      })
    );
  };

  return (
    <section className="py-6 md:pb-10">
      <div className="mx-auto max-w-7xl px-5 lg:px-6">

        {/* HEADER */}
        <div>
          <div className="mb-2 flex items-center gap-4 text-left md:justify-center md:text-center">
            <span className="inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
              Handpicked Destinations
            </span>
          </div>

          <h2 className="text-left text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-[#12344A] md:text-center md:text-[46px]">
            Popular Countries <span>to Explore</span>
          </h2>

          <p className="mx-auto flex max-w-[750px] justify-center pt-2 text-left text-[15px] leading-8 text-slate-500 md:text-center md:text-lg">
            We're curating experiences that match your travel style, timing,
            and preferences. Explore handpicked destinations tailored just for
            you.
          </p>
        </div>

        {/* SLIDER BUTTONS */}
        <div className="mb-9 flex items-end justify-end gap-5 md:scroll-mt-32"  id="tour-packages">
          <div className="flex shrink-0 gap-2.5">

            {/* PREVIOUS */}
            <button
              type="button"
              onClick={() => scrollSlider("prev")}
              aria-label="Previous destination"
              disabled={activeSlide === 0}
              className={`flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-[#12344A] shadow-[0_7px_20px_rgba(18,52,74,0.08)] transition-all duration-300 ${
                activeSlide === 0
                  ? "cursor-not-allowed opacity-40"
                  : "hover:border-[#019EE7] hover:bg-[#019EE7] hover:text-white"
              }`}
            >
              <i className="las la-arrow-left text-xl" />
            </button>

            {/* NEXT */}
            <button
              type="button"
              onClick={() => scrollSlider("next")}
              aria-label="Next destination"
              disabled={activeSlide >= displayDestinations.length - 1}
              className={`flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#019EE7] to-[#007FC0] text-white shadow-[0_9px_24px_rgba(1,158,231,0.28)] transition-all duration-300 ${
                activeSlide >= displayDestinations.length - 1
                  ? "cursor-not-allowed opacity-40"
                  : "hover:-translate-y-0.5"
              }`}
            >
              <i className="las la-arrow-right text-xl" />
            </button>

          </div>
        </div>

        {/* SLIDER */}
        <div
          ref={sliderRef}
          onScroll={handleSliderScroll}
          className="flex snap-x snap-mandatory gap-[15px] overflow-x-auto scroll-smooth pb-5"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {displayDestinations.map((destination, index) => {
            const liked = likedCards.includes(index);

            return (
              <a href={destination.href}
                key={`${destination.title}-${index}`}
                data-slide-card
                // onClick={() => handleExplore(destination)}
                className="group relative flex-none w-[88%] cursor-pointer snap-start overflow-hidden rounded-[22px] border border-slate-200 bg-white shadow-[0_10px_30px_rgba(18,52,74,0.09)] transition-all duration-500 hover:-translate-y-2 hover:border-[#019EE7]/30 sm:w-[68%] md:w-[48%] xl:w-[calc((100%-40px)/4)]"
              >
                {/* IMAGE */}
                <div className="relative h-[240px] overflow-hidden">
                  <img
                    src={destination.image}
                    alt={destination.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />

                  {/* PREMIUM BADGE */}
                  <div className="absolute left-2 top-4 flex items-center gap-2 rounded-full bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-2 py-1 text-[8px] font-extrabold uppercase tracking-[1.2px] text-white shadow-[0_8px_20px_rgba(0,0,0,0.18)] backdrop-blur-xl">
                    <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#A8C94A]/20">
                      <i className="las la-plane text-sm text-white" />
                    </span>
                    Premium
                  </div>
                </div>

                {/* CONTENT */}
                <div className="px-5 pt-4">

                  {/* LOCATION + RATING */}
                  <div className="mb-3.5 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-[13px] font-medium text-slate-700">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#019EE7]/10">
                        <i className="las la-route text-lg text-[#019EE7]" />
                      </span>

                      {destination.places}
                    </div>

                    <div className="flex items-center gap-1.5 text-[14px] font-medium text-[#668B28]">
                      <i className="las la-star text-base text-[#A8C94A]" />
                      {destination.rating}
                    </div>
                  </div>

                  {/* TITLE */}
                  <h3 className="mb-3 min-h-[48px] text-[18px] font-semibold leading-[1.35] tracking-[-0.3px] text-[#12344A] transition-colors duration-300">
                    {destination.title}
                  </h3>
                </div>

                {/* PREMIUM SERVICES STRIP */}
                {/* <div className="mx-3 mb-3 mt-2 overflow-hidden rounded-xl border border-[#019EE7]/30 bg-white">
                  <div className="relative overflow-hidden rounded-[17px] bg-white">
                    <div className="relative grid grid-cols-4">
                      <div className="group relative flex flex-col items-center justify-center px-2 py-3 text-center transition-all duration-300 hover:bg-[#019EE7]/[0.02]">
                        <div className="mb-1.5 flex h-8 w-8 items-center justify-center rounded-[10px] border border-[#019EE7]/15 bg-gradient-to-br from-[#019EE7]/[0.10] to-[#97BF49]/[0.08] text-[#019EE7] backdrop-blur-md transition-all duration-300 group-hover:scale-105">
                          <i className="las la-binoculars text-[20px]" />
                        </div>

                        <span className="text-[9px] font-semibold tracking-[0.5px] text-slate-600 group-hover:text-[#019EE7]">
                          Sightseeing
                        </span>

                        <div className="absolute right-0 top-1/2 h-8 w-px -translate-y-1/2 bg-[#019EE7]/10" />
                      </div>
                      <div className="group relative flex flex-col items-center justify-center px-2 py-3 text-center transition-all duration-300 hover:bg-[#97BF49]/[0.02]">
                        <div className="mb-1.5 flex h-8 w-8 items-center justify-center rounded-[10px] border border-[#97BF49]/20 bg-gradient-to-br from-[#97BF49]/[0.12] to-[#019EE7]/[0.07] text-[#759F2F] backdrop-blur-md transition-all duration-300 group-hover:scale-105">
                          <i className="las la-car text-[20px]" />
                        </div>

                        <span className="text-[9px] font-semibold tracking-[0.5px] text-slate-600 group-hover:text-[#759F2F]">
                          Transfers
                        </span>

                        <div className="absolute right-0 top-1/2 h-8 w-px -translate-y-1/2 bg-[#019EE7]/10" />
                      </div>
                      <div className="group relative flex flex-col items-center justify-center px-2 py-3 text-center transition-all duration-300 hover:bg-[#019EE7]/[0.02]">
                        <div className="mb-1.5 flex h-8 w-8 items-center justify-center rounded-[10px] border border-[#019EE7]/15 bg-gradient-to-br from-[#019EE7]/[0.10] to-[#97BF49]/[0.08] text-[#019EE7] backdrop-blur-md transition-all duration-300 group-hover:scale-105">
                          <i className="las la-compass text-[20px]" />
                        </div>

                        <span className="text-[9px] font-semibold tracking-[0.5px] text-slate-600 group-hover:text-[#019EE7]">
                          Experiences
                        </span>

                        <div className="absolute right-0 top-1/2 h-8 w-px -translate-y-1/2 bg-[#019EE7]/10" />
                      </div>

                      <div className="group flex flex-col items-center justify-center px-2 py-3 text-center">
                        <div className="mb-1.5 flex h-8 w-8 items-center justify-center rounded-[10px] border border-[#97BF49]/20 bg-gradient-to-br from-[#97BF49]/[0.12] to-[#019EE7]/[0.07] text-[#759F2F] backdrop-blur-md transition-all duration-300 group-hover:scale-105">
                          <i className="las la-hotel text-[20px]" />
                        </div>

                        <span className="text-[9px] font-semibold tracking-[0.5px] text-slate-600 group-hover:text-[#759F2F]">
                          Stays
                        </span>
                      </div>

                    </div>
                  </div>
                </div> */}
              </a>
            );
          })}
        </div>

        {/* SLIDER DOTS */}
        <div className="mt-4 flex items-center justify-center gap-2">
          {displayDestinations.map((_, index) => (
            <button
              key={index}
              type="button"
              onClick={() => scrollToSlide(index)}
              aria-label={`Slide ${index + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                activeSlide === index
                  ? "w-10 bg-gradient-to-r from-[#019EE7] to-[#007FC0]"
                  : "w-1.5 bg-slate-200"
              }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}

export default DestinationSection;